module.exports = window.Next;